// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : created Types
// MODIFIED DATE : 06-10-2025

const ENACHReportActionTypes = {
	/** ***************** MANDATE DETAILS REPORT START *********************** */
	FETCH_ENACH_MANDATE_REPORT_START: 'fetch_mandate_enach_report_Start',
	FETCH_ENACH_MANDATE_REPORT_SUCCESS: 'fetch_mandate_enach_report_Success',
	FETCH_ENACH_MANDATE_REPORT_FAILURE: 'fetch_mandate_enach_report_Failure',
	FETCH_ENACH_MANDATE_REPORT_RESPONSE_RESET: 'fetch_mandate_enach_report_ResponseReset',
	FETCH_ENACH_MANDATE_REPORT_RESPONSE_CHANGED: 'fetch_mandate_enach_report_ResponseChanged',
	/** ***************** MANDATE DETAILS REPORT END *********************** */
};
export default ENACHReportActionTypes;
